import clsx from 'clsx';
import { makeStyles, Typography } from '@material-ui/core';
import { ReactComponent as Success } from '../../assets/svg/success.svg';
import { ReactComponent as Error } from '../../assets/svg/error.svg';
import { ReactComponent as Warning } from '../../assets/svg/warning.svg';

interface Props {
  responseType: 'error' | 'success' | 'warning';
  message?: string | undefined;
  subMessage?: string;
  isToast?: boolean;
}

export const ResponseMessage = ({
  responseType,
  message,
  subMessage,
  isToast = false,
}: Props) => {
  let defaultMessage;
  const classes = useStyles();

  const getIcon = (responseType: string) => {
    switch (responseType) {
      case 'error':
        defaultMessage = 'Error';
        return <Error />;
      case 'success':
        defaultMessage = 'Success';
        return <Success />;
      case 'warning':
        defaultMessage = 'Warning';
        return <Warning />;
      default:
        return <Success />;
    }
  };

  return (
    <div
      className={clsx(classes.container, {
        [classes.toast]: isToast,
        '!p-12': !isToast,
      })}
    >
      <div
        className={clsx(classes.iconContainer, {
          [classes.smallIcon]: isToast,
        })}
      >
        {getIcon(responseType)}
      </div>
      <div className={classes.messageContainer}>
        <Typography
          className={clsx(classes.message, { [classes.toastMessage]: isToast })}
          variant="h6"
        >
          {message ? message : defaultMessage}
        </Typography>
        {subMessage ? (
          <Typography
            className={clsx(classes.subMessage, {
              [classes.toastSubMessage]: isToast,
            })}
            variant="body1"
          >
            {subMessage}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  iconContainer: {
    display: 'flex',
    width: 150,
    height: 150,
    margin: 10,
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  message: {
    display: 'flex',
    fontSize: '1.5rem',
  },
  subMessage: {
    fontSize: '0.75rem',
    opacity: 0.6,
  },
  error: {
    color: '#e83a45',
  },
  success: {
    color: '#8dc63f',
  },
  smallIcon: {
    width: 30,
    height: 30,
  },
  toast: {
    flexDirection: 'row',
  },
  toastMessage: {
    fontSize: '1rem',
  },
  toastSubMessage: {
    fontSize: '0.75rem',
  },
}));
